import { Component } from '@angular/core';
import { Article } from '../shared/models/article.interface';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-uploads',
    templateUrl: './uploads.component.html',
    styleUrls: ['./uploads.component.scss'],
    standalone: false
})
export class UploadsComponent {
  closeResult = '';
  modalContent: Article | undefined;
  
  constructor(
    private modalService: NgbModal, private http: HttpClient
  ) {
  }

  ngOnInit(): void {
  }

  /**
   * Opens the modal to select an Excel file for upload, display rows, and upload file.
   * @param excelImportModal the modal to open
   */
  openExcelImport(excelImportModal: any) {
    this.modalService
      .open(excelImportModal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Opens the modal to select an Excel file, select a Thermal Method for mapping the excel data, preview data, and upload file.
   * @param excelVarietyImportModal 
   */
  openExcelVarietyImport(excelVarietyImportModal: any) {
    this.modalService
      .open(excelVarietyImportModal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Opens the modal to select a DXF file for upload, confirm the file selected, and upload file.
   */
  openDxfImport(dxfImportModal: any) {
    this.modalService
      .open(dxfImportModal, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'fluid-modal',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Handles modal dismissal
   * @param reason reason for modal dismissal (how)
   */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  downloadExcel() {
    const fileUrl = 'assets/templates/SampleArticleUploadExcel.xlsx'; // Path to your Excel file in the assets folder

    this.http.get(fileUrl, { responseType: 'blob' }).subscribe((response: Blob) => {
      // Use file-saver to save the file with a specific name
      saveAs(response, 'SampleArticleUploadExcel.xlsx');
    }, error => {
      console.error('Error downloading the file:', error);
    });
  }
  

}
